import firebase from 'firebase/app';
import 'firebase/firestore';

firebase.initializeApp({
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
});

// Get a Firestore instance
firebase.firestore().settings({});
firebase.firestore().enablePersistence({ synchronizeTabs: true });

export const db = firebase.firestore();
export const { FieldValue, Timestamp } = firebase.firestore;
